import { registerSystemInfoTab } from "routes/sfg20-admin/plugins/system-info/register-system-info-tab"
import StatsAnalysis from "routes/sfg20-admin/plugins/system-info/activity-tab/analysis"

registerSystemInfoTab("Activity", <StatsAnalysis $lazy />, 3)
